import { isClient } from "../env-utils/env-utils"
import { LogLevel, LoggerConfig } from "./ILogger"
import Logger from "./Logger"

const logLevel = isClient
    ? process.env.NEXT_PUBLIC_BROWSER_LOG_LEVEL || "warn"
    : process.env.LOG_LEVEL || "warn"
const logDepthLimit = Number(process.env.LOG_DEPTH_LIMIT || 5)
const logPrettyPrint = process.env.LOG_PRETTY_PRINT === "true"

export const getLogLevel = (level: string): LogLevel => {
    switch (level.toLowerCase()) {
        case "trace":
            return LogLevel.Trace
        case "debug":
            return LogLevel.Debug
        case "info":
            return LogLevel.Info
        case "warn":
            return LogLevel.Warn
        case "error":
            return LogLevel.Error
        default:
            return LogLevel.Info
    }
}

const loggerConfig: LoggerConfig = {
    logLevel: getLogLevel(logLevel),
    depthLimit: logDepthLimit,
    prettyPrintOutput: logPrettyPrint
}

const logger = new Logger(loggerConfig)

logger.info(`Logger initialized with log level: [${logLevel.toUpperCase()}]`)

export default logger
